<template>
	<div
		class="social-bar"
		@click="handleClick(socialType)"
		:class="{ active: socialType.selected }"
		tabindex="0"
	>
		<div class="social-wrapper">
			<span class="social-icon"
				><font-awesome-icon :icon="[iconWeight, icon]"
			/></span>
			<span class="social-name">{{ socialName }}</span>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'SocialBar',
	props: {
		socialName: String,
		icon: String,
		iconWeight: String,
		socialType: Object,
	},
	methods: {
		...mapActions(['selectSocialType']),

		handleClick(data) {
			this.selectSocialType(data);
			this.$emit('click', data.selected);
		},
	},
};
</script>

<style lang="scss" scoped>
.social-bar {
	@include rem('padding', 9px 15px);
	display: flex;
	justify-content: space-between;
	align-items: center;
	box-shadow: none;
	border-radius: $b360-border-radius-base;
	border: $b360-border-width-thin $border-color-light solid;
	transition: $b360-motion-selection;
	background-color: $off-white;
	cursor: pointer;

	&:hover {
		border-color: $b360-color--gray__medium;
		box-shadow: 0 0 6px $shadow-color;
	}
}

.social-wrapper {
	display: flex;
	align-items: center;
}

.social-icon {
	color: $brand-teal;
	@include rem('font-size', 26px);
	@include rem('margin-right', 16px);
}

.social-name {
	color: $text-base-color;
	font-size: $b360-font-size--base;
	font-weight: 500;
}
</style>
